// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { ReactComponent as BackIcon } from "../../../../../assets/svgs/back-button.svg";
// import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
// import { useSelector } from "react-redux";
// import { getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import dayjs from "dayjs";
// import { Button } from "antd";
// import SupportReplyDialog from "../DialogBoxes/SupportReplyDialog";
// import { IoArrowBackCircleOutline } from "react-icons/io5";

// const SupportAction = () => {
//   const navigate = useNavigate();
//   const { ticketId } = useParams();
//   const token = useSelector((state) => state.auth.authToken);
//   const [formData, setFormData] = useState({
//     customerName: "",
//     userName: "",
//     email: "",
//     helpText: "",
//     createdOn: "",
//     communications: [],
//   });
//   const [openReplyDialog, setOpenReplyDialog] = useState(false);

//   const handleReplyClick = () => {
//     setOpenReplyDialog(true);
//   };

//   const handleReplySuccess = () => {
//     setOpenReplyDialog(false);
//   };
//   const fetchData = async (ticketId) => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.TICKET_DETAILS(ticketId),
//       });

//       if (response.success) {
//         setFormData({
//           customerName: response.data.customer_name,
//           userName: response.data.user_name,
//           email: response.data.email_id,
//           helpText: response.data.communication?.[0]?.message || "",
//           createdOn: dayjs(response.data.email_id.createdAt).format(
//             "DD/MM/YYYY",
//           ),
//           communications: response.data.communication || [],
//           // query_createdAt:
//           //   dayjs(response.data.communication?.[0]?.createdAt).format(
//           //     "DD/MM/YYYY hh:mm A"
//           //   ) || ""
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     if (ticketId) {
//       fetchData(ticketId);
//     }
//   }, [ticketId]);

//   return (
//     <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       <div className="flex items-center gap-2 text-xl font-bold">

//          <IoArrowBackCircleOutline
//                   onClick={() => navigate("/organization/support")}
//                     className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
//                   />
//                    <TextStyles color="gradient" style={{ marginTop: "18px" }}>
//           {ticketId}
//         </TextStyles>
//       </div>

//       <div
//         style={{
//           border: "1px solid #3BA2B959",
//           borderRadius: "10px",
//           padding: "20px",
//           boxShadow: "0px 0px 16px 0px #3BA2B91F",
//           backgroundColor:"#fff"
//         }}
//       >
//         <form className="space-y-4 my-20">
//           <div className="flex justify-between mx-20 mb-16">
//             <div>
//               <label className="block font-semibold text-gray-500">
//                 Customer Name
//               </label>
//               <input
//                 type="text"
//                 name="customerName"
//                 value={formData.customerName}
//                 disabled
//                 className=" p-2 border-b bg-gray-100 cursor-not-allowed"
//               />

//               <label className="block font-semibold text-gray-500 mt-8">
//                 Contact No
//               </label>
//               <input
//                 type="text"
//                 name="contactNumber"
//                 value="N/A"
//                 disabled
//                 className=" p-2 border-b bg-gray-100 cursor-not-allowed"
//               />
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-500">
//                 User Name
//               </label>
//               <input
//                 type="text"
//                 name="userName"
//                 value={formData.userName}
//                 disabled
//                 className=" p-2 border-b bg-gray-100 cursor-not-allowed"
//               />

//               <label className="block font-semibold text-gray-500 mt-8">
//                 Ticket ID
//               </label>
//               <input
//                 type="text"
//                 name="contactNumber"
//                 value={ticketId}
//                 disabled
//                 className=" p-2 border-b bg-gray-100 cursor-not-allowed"
//               />
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-500 ">
//                 Email ID
//               </label>
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 disabled
//                 className=" p-2 border-b bg-gray-100 cursor-not-allowed"
//               />

//               <label className="block font-semibold text-gray-500 mt-8">
//                 Created Date
//               </label>
//               <input
//                 type="text"
//                 name="contactNumber"
//                 value={formData.createdOn}
//                 disabled
//                 className=" p-2 border-b bg-gray-100 cursor-not-allowed"
//               />
//             </div>
//           </div>

//           <div   style={{ backgroundColor: "#B1C8C2" }}  className="py-4">
//             <div className="text-center">
//               <div className="space-y-4 max-h-[400px] overflow-y-auto px-6">
//                 {formData.communications.map((comm, index) => (
//                   <div
//                     key={index}
//                     className="bg-gray-100 text-left rounded-none p-4 shadow-sm"
//                   >
//                     <div className="text-sm font-semibold">
//                       {comm.userType === "support" ? "Support" : "Customer"}:
//                     </div>
//                     <div className="flex justify-between items-end">
//                       <div className="text-sm mt-1">{comm.message}</div>
//                       <div className="text-xs text-gray-500 mt-1">
//                         {dayjs(comm.createdAt).format("DD/MM/YYYY hh:mm A")}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="text-center my-5">
//               <Button

//                 style={{ background: "#06513D" }}
//                 className="text-sm text-white font-light px-10 py-5 rounded-md"
//                 onClick={handleReplyClick}
//               >
//                 Reply
//               </Button>
//             </div>
//             <SupportReplyDialog
//               onOpen={openReplyDialog}
//               onClose={() => setOpenReplyDialog(false)}
//               ticketId={ticketId}
//               onSubmit={handleReplySuccess}
//             />
//             {/* <div className="text-center my-5">
//               <Button
//                 type="primary"
//                 style={{ background: "#0087A3" }}
//                 className="text-sm text-white font-light px-10 py-5 rounded-md"
//               >
//                 Reply
//               </Button>
//             </div> */}
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default SupportAction;

import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../../../assets/svgs/back-button.svg";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import { useSelector } from "react-redux";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import dayjs from "dayjs";
import { Button } from "antd";
import SupportReplyDialog from "../DialogBoxes/SupportReplyDialog";
import { IoArrowBackCircleOutline } from "react-icons/io5";

const SupportAction = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { ticketId } = useParams();
  const token = useSelector((state) => state.auth.authToken);
  const [formData, setFormData] = useState({
    customerName: "",
    userName: "",
    email: "",
    contactNumber: "",
    helpText: "",
    createdOn: "",
    communications: [],
  });
  const [openReplyDialog, setOpenReplyDialog] = useState(false);

  const handleReplyClick = () => {
    setOpenReplyDialog(true);
  };

  const handleReplySuccess = () => {
    setOpenReplyDialog(false);
  };

  const fetchData = async (ticketId) => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.TICKET_DETAILS(ticketId),
      });

      if (response.success) {
        setFormData({
          customerName: response.data.customer_name,
          userName: response.data.user_name,
          email: response.data.email_id,
          contactNumber: response.data.contact_no || "",
          helpText: response.data.communication?.[0]?.message || "",
          createdOn: dayjs(response.data.createdAt).format("DD/MM/YYYY"),
          communications: response.data.communication || [],
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (ticketId) {
      fetchData(ticketId);
    }
  }, [ticketId]);

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      <div className="flex items-center gap-2 text-xl font-bold">
        <IoArrowBackCircleOutline
          onClick={() =>
            navigate("/organization/support", { state: location.state })
          }
          className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer"
        />
        <TextStyles style={{ marginTop: "18px", color: "#06513D" }}>
          {/* {ticketId} */} Support Ticket
        </TextStyles>
      </div>

      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
          backgroundColor: "#fff",
        }}
      >
        <form className="space-y-4 my-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 sm:px-6 md:px-10 mb-16">
            <div>
              <label className="block font-semibold text-gray-500">
                Customer Name
              </label>
              <input
                type="text"
                name="customerName"
                value={formData.customerName}
                disabled
                className="w-full p-2 border-b bg-gray-100 cursor-not-allowed"
              />

              <label className="block font-semibold text-gray-500 mt-4">
                Contact No
              </label>
              <input
                type="text"
                name="contactNumber"
                value={formData.contactNumber || "N/A"}
                disabled
                className="w-full p-2 border-b bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block font-semibold text-gray-500">
                User Name
              </label>
              <input
                type="text"
                name="userName"
                value={formData.userName}
                disabled
                className="w-full p-2 border-b bg-gray-100 cursor-not-allowed"
              />

              <label className="block font-semibold text-gray-500 mt-4">
                Ticket ID
              </label>
              <input
                type="text"
                name="ticketId"
                value={ticketId}
                disabled
                className="w-full p-2 border-b bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block font-semibold text-gray-500">
                Email ID
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                disabled
                className="w-full p-2 border-b bg-gray-100 cursor-not-allowed"
              />

              <label className="block font-semibold text-gray-500 mt-4">
                Created Date
              </label>
              <input
                type="text"
                name="createdOn"
                value={formData.createdOn}
                disabled
                className="w-full p-2 border-b bg-gray-100 cursor-not-allowed"
              />
            </div>
          </div>

          <div style={{ backgroundColor: "#B1C8C2" }} className="py-4">
            <div className="text-center">
              <div className="space-y-4 max-h-[400px] overflow-y-auto px-6">
                {formData.communications.map((comm, index) => (
                  <div
                    key={index}
                    className="bg-gray-100 text-left rounded-none p-4 shadow-sm"
                  >
                    <div className="text-sm font-semibold">
                      {comm.userType === "support" ? "Support" : "Customer"}:
                    </div>
                    <div className="flex justify-between items-end">
                      <div className="text-sm mt-1">{comm.message}</div>
                      <div className="text-xs text-gray-500 mt-1">
                        {dayjs(comm.createdAt).format("DD/MM/YYYY hh:mm A")}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="text-center my-5">
              <button
                type="button"
                style={{ background: "#06513D" }}
                className="text-sm text-white font-light px-10 py-3 rounded-md"
                onClick={handleReplyClick}
              >
                Reply
              </button>
            </div>

            <SupportReplyDialog
              onOpen={openReplyDialog}
              onClose={() => {
                setOpenReplyDialog(false);
                fetchData(ticketId);
              }}
              ticketId={ticketId}
              onSubmit={handleReplySuccess}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default SupportAction;
